module.exports = __webpack_public_path__ + "img/webServiceError.e0e1a24b.jpg";